import {signal} from "@preact/signals-react";

export const openUserPopover = signal(null)

export const handleLangPopoverClose = () => openUserPopover.value = null